import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../styling/breakpointsMinWidth';
import { white } from '../../../../../../styling/theme';
import scrollBar from '../../Editor/shared/scrollBar';

export const PopUpWrapper = styled.div`
  visibility: ${(props) => (props.jobDescriptionPopup ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 103;
  transform: scale(1.3) translate(-40%, -40%);
  width: 460px;
  height: 301px;
  background: white;
  border-radius: 8px;
  padding: 14px 14px 12px 14px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transition: all 0.3s ease-in-out;

  ${(props) => {
    const { jobDescriptionPopup } = props;
    if (jobDescriptionPopup) {
      return css`
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      `;
    }
    return null;
  }}

  @media ${breakpointsMinWidth.tabletMd} {
    width: 500px;
    height: 327px;
    padding: 14px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    width: 520px;
    height: 340px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    width: 540px;
    height: 353px;
    padding: 16px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 624px;
    height: 408px;
  }
`;

export const InputsWrap = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;

  @media ${breakpointsMinWidth.tabletMd} {
    margin-bottom: 12px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    margin-bottom: 14px;
  }
`;
export const InputLabelText = styled.div`
  font-size: 14px;
  line-height: 14px;
  width: 100%;
  margin-bottom: 12px;
  text-align: left;
`;

export const PlaceholderTextSpan = styled.div`
  position: absolute;
  font-size: 14px;
  padding: 0 4px;
  padding: ${({ coverLetterPopup }) => (coverLetterPopup ? '0 8px' : '0 4px')};
  line-height: 12px;
  font-style: italic;
  color: #878787;
  top: 10px;
  transition: all 0.2s ease;
  cursor: auto;
  background: #fff;
  pointer-events: none;
  ${(props) => {
    const { isEmpty } = props;
    if (!isEmpty) {
      return css`
        transform: translateY(-140%);
        font-size: 12px;
      `;
    }
    return null;
  }}
`;

export const InputField = styled.label`
  width: 100%;
  position: relative;
  height: 38px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 7px 10px 7px 6px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 7px 12px 7px 8px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 9px 14px 9px 10px;
  }
`;

export const JobDescriptionField = styled.label`
  width: 100%;
  position: relative;
  flex: 1;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 7px 0px 7px 6px;
  margin-bottom: 0;
  @media ${breakpointsMinWidth.desktopSm} {
    padding: 7px 0px 7px 8px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 9px 0px 9px 10px;
  }
`;

export const InputSpan = styled.input`
  width: 100%;
  font-size: 14px;
  line-height: 14px;
  text-align: left;
  border: none;
  padding: 0;
  &:focus {
    outline: none;
    + div {
      transform: translateY(-140%);
      font-size: 10px;
    }
  }
`;

export const DescriptionSpan = styled.textarea`
  width: 100%;
  height: 240px;
  resize: none;
  font-size: 14px;
  line-height: 14px;
  text-align: left;
  border: none;
  padding: 0;
  padding-right: 14px;
  ${({ coverLetterPopup }) =>
    coverLetterPopup
      ? css`
          min-height: 142px;
          @media ${breakpointsMinWidth.tabletLg} {
            min-height: 160px;
          }
          @media ${breakpointsMinWidth.desktopMd} {
            min-height: 180px;
          }
        `
      : null}

  ${() => {
    const scrollBarStyles = () => scrollBar({ width: '6px', height: '6px' });

    return css`
      ${scrollBarStyles}
      overflow-x: hidden;
    `;
  }};

  &:focus {
    outline: none;
    + div {
      transform: translateY(-140%);
      font-size: 12px;
    }
  }
`;

export const AddLinkWrap = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

export const JobDescriptionWrap = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  ${({ coverLetterPopup }) => {
    if (coverLetterPopup) {
      return css`
        margin-bottom: 24px;
      `;
    }
    return null;
  }}
`;

export const ButtonsWrap = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;
export const FormButton = styled.button`
  width: 56px;
  height: 28px;
  background: ${(props) => props.bgColor};
  opacity: ${(props) => (props.isSavingData ? '0.8' : '1')};
  cursor: ${(props) => (props.isSavingData ? 'not-allowed' : 'auto')};
  color: ${(props) => props.color};
  border: ${(props) => (props.border ? '1px solid #000000' : 'none')};
  font-size: 11px;
  line-height: 14px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;

    &:disabled:hover {
      background: ${(props) => props.bgColor};
    }
  }

  &:hover {
    opacity: 0.9;
    color: ${white};
    border: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0px;
    left: -60px;
    width: 300px;
    height: 300px;
    background-color: rgb(18, 34, 65);
    border-color: transparent;
    border-radius: 50%;
    transform: translate(-20%, -45%) scale(0.05);
    opacity: 0;
    z-index: -1;
    transition:
      transform 0.4s,
      opacity 0.4s,
      background-color 0.4s ease-in-out;
  }

  &:hover::after {
    opacity: 1;
    transform-origin: 150px 150px;
    transform: scale(1) translate(-10%, -42%);
  }

  @media ${breakpointsMinWidth.tabletLg} {
    width: 60px;
    height: 30px;
    font-size: 12px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 64px;
    height: 32px;
  }
`;
export const FormButtons = styled.div`
  width: 184px;
  display: flex;
  justify-content: space-between;
  height: 100%;
  position: relative;
  overflow: hidden;
  @media ${breakpointsMinWidth.tabletLg} {
    width: 200px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 216px;
  }
`;

export const CategoryWrap = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;
export const Categories = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  @media ${breakpointsMinWidth.desktopSm} {
    gap: 16px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    gap: 24px;
  }
`;
export const Category = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: #000;
  width: max-content;
  height: 32px;
  border: 1px solid rgba(46, 53, 62, 0.87);
  border-radius: 4px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: ${({ isLast }) => (isLast ? '0px' : '10px')};

  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 12px;
  }

  ${(props) => {
    const { active } = props;
    if (active) {
      return css`
        background: #4285f4;
        color: #fff;
        border: 1px solid #4285f4;
      `;
    }
    return null;
  }}
`;
